import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const observationAttachmentsNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.observation_attachments_list, {
      displayName: 'Observations',
      icon: SolIcon.finding,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
